import request from '@/utils/request';

// 非投标保函-统一填写页内部接口（免登录，SecurityConfig 放行 /api/nonbid/apply/**）

export function detail(params) {
  return request({
    url: '/api/nonbid/apply/detail',
    method: 'get',
    params,
  });
}

export function save(data) {
  return request({
    url: '/api/nonbid/apply/save',
    method: 'post',
    data,
  });
}

export function submit(data) {
  return request({
    url: '/api/nonbid/apply/submit',
    method: 'post',
    data,
  });
}

export function payUrl(params) {
  return request({
    url: '/api/nonbid/apply/payUrl',
    method: 'get',
    params,
  });
}

export function delFile(data) {
  return request({
    url: '/api/nonbid/apply/delFile',
    method: 'post',
    data,
  });
}

export function applyInvoice(data) {
  return request({
    url: '/api/nonbid/apply/applyInvoice',
    method: 'post',
    data,
  });
}

export function applyRefund(data) {
  return request({
    url: '/api/nonbid/apply/applyRefund',
    method: 'post',
    data,
  });
}
